import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const editOrderActions = createActionGroup({
  source: 'Edit Order',
  events: {
    'Clear state': emptyProps(),
    'Cancel order': props<{ orderId: string }>(),
    'Check cancel state': emptyProps(),
    'Check trading times': props<{ isin: string }>(),
    'Reset timer': emptyProps(),
  },
});

export const editOrderApiActions = createActionGroup({
  source: 'Edit Order API',
  events: {
    'Cancel order success': emptyProps(),
    'Cancel order failure': props<{ error: HttpErrorResponse }>(),
    'Check cancel state success': props<{ isCancellationDone: boolean }>(),
    'Check cancel state failure': props<{ error: HttpErrorResponse }>(),
    'Check trading times success': props<{ isOutOfTradingTimes: boolean }>(),
    'Check trading times failure': props<{ error: HttpErrorResponse }>(),
  },
});
